export const fetchuserContextFromAPI = () => {
  var ajaxResponseData = null;
  async function fetchData(){
    try{
      const response = await $.ajax({
        url: '/wcs/resources/store/301/usercontext/@self/contextdata',
        datatype: "json",
        type: "GET",
        contentType: "application/json",
      });
      ajaxResponseData = response;
      return ajaxResponseData;
    }
    catch(error){
      console.error("Error Fetching the API Data", error);
    }
  }
  return fetchData();
};